import React from 'react';
import { useSlidesContent } from '../../context';
import SlideRenderer from '../SlideRenderer';
import styles from './styles.module.css';
import { type Slide } from '../../_data';

const NavPanel = React.memo(
  ({ panelOpen }: { panelOpen: boolean }): React.ReactElement => {
    const { slides, currentSlide, setCurrentSlide, type } = useSlidesContent();

    const handleClick = (slide: Slide<any>) => {
      setCurrentSlide(slide);
    };

    const getSlideKey = (slide: Slide<any>, index: number) => {
      const contentHash = JSON.stringify(slide.content);
      return `${index + 1}-${slide.slideTemplateId}-${contentHash}`;
    };

    return (
      <div
        className={styles.panel}
        aria-hidden={!panelOpen}
        id="slides-nav-panel"
      >
        {slides.map((slide, index) => (
          <article className={styles.item} key={getSlideKey(slide, index)}>
            <div className={styles.number}>{index + 1}</div>
            <div
              onClick={() => handleClick(slide)}
              className={styles.button}
              aria-current={
                currentSlide.slideTemplateId === slide.slideTemplateId
              }
            >
              <div
                className={
                  type === 'premium_report'
                    ? styles.premiumReport
                    : styles.viewportMini
                }
                aria-current={
                  currentSlide.slideTemplateId === slide.slideTemplateId
                }
              >
                <SlideRenderer slide={slide} type={type} />
              </div>
            </div>
          </article>
        ))}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.panelOpen === nextProps.panelOpen,
);

export default NavPanel;
